var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"section"},[_c('b-row',{staticClass:"text-center align-items-center justify-content-center"},[_vm._t("default")],2),(_vm.lineAfter)?_c('hr'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }